import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectLifts = createSelector(selectJsonQuery, jsonQuery => getTermValue('lifts')(jsonQuery));
